import React from 'react'
import styled from 'styled-components'

import Checkbox from 'components/Checkbox'
import Textarea from 'components/Textarea'
import TextInput from 'components/TextInput'

import FormSection from 'pages/shared/FormSection'
import TextAreaWithPreview from 'pages/shared/TextAreaWithPreview'

import { scrubText } from 'helpers/inputCleaners'
import { DeviceMetricFormErrors } from 'types/DeviceMetric'
import { screenSize } from 'styles/shared'

interface Props {
  validatedSaveType: string,
  id: string,
  name: string,
  description: string,
  callToAction: string,
  unit: string,
  draft: boolean
  color: string
  onChangeCallback: (event) => void
  errors: DeviceMetricFormErrors
}

const MetricFields = ({ validatedSaveType, id, name, description, unit, callToAction, draft, color, onChangeCallback, errors }: Props) => {
  return (
    <FormSection title="Device Metric">
      <S.Checkbox
        label="Draft"
        checked={draft}
        onChange={() => onChangeCallback({ draft: !draft })}
        errorMessage={errors?.draft}
      />
      <S.TextInput
        label="ID"
        isRequired
        onChange={event => onChangeCallback({ id: scrubText(event.target.value, true) })}
        value={id || ''}
        readOnly={validatedSaveType === 'update'}
        errorMessage={errors?.id}
        placeholder="example_metric_id"
      />
      <S.TextInput
        label="Name"
        isRequired
        onChange={event => onChangeCallback({ name: scrubText(event.target.value, true) })}
        value={name || ''}
        errorMessage={errors?.name}
      />
      <S.Container>
        <S.TextInput
          label="Color"
          type="color"
          isRequired
          onChange={event => onChangeCallback({ color: scrubText(event.target.value, false) })}
          value={color}
          errorMessage={errors?.color}
        />
        <S.TextInput
          label="Unit"
          onChange={event => onChangeCallback({ unit: scrubText(event.target.value, true) })}
          value={unit || ''}
          readOnly={validatedSaveType === 'update'}
          errorMessage={errors?.unit}
        />
      </S.Container>
      <Textarea
        label="Description"
        onChange={event => onChangeCallback({ description: scrubText(event.target.value, true) })}
        value={description || ''}
        errorMessage={errors?.description}
        isRequired
      />
      <TextAreaWithPreview
        label="Call to Action"
        value={callToAction}
        onChange={event => onChangeCallback({ callToAction: scrubText(event.target.value) })}
        errorMessage={errors?.callToAction}
      />
    </FormSection>
  )
}

export default MetricFields

const S = {
  Checkbox: styled(Checkbox)`
    width: 50%;
  `,
  TextInput: styled(TextInput)`
    width: 50%;

    input {
      padding-right: 8px;
    }

    @media ${screenSize.small} {
      width: 100%;
    }
  `,
  Container: styled.div`
    display: flex;
    width: 50%;
    gap: 10px;

    @media ${screenSize.small} {
      width: 100%;
    }
  `
}
